var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSatelliteColor = function SvgSatelliteColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.139 21.336a1.7 1.7 0 0 1-.577-.102 1.4 1.4 0 0 1-.502-.32l-3.55-3.55a1.4 1.4 0 0 1-.32-.501 1.67 1.67 0 0 1 0-1.147q.103-.268.32-.484l2.79-2.79q.44-.441 1.07-.444.628-.003 1.069.438L7.9 13.897l.627.627 1.462 1.462q.44.44.438 1.07-.003.628-.444 1.068l-2.79 2.79a1.4 1.4 0 0 1-.484.32 1.6 1.6 0 0 1-.57.102m0-.956a.45.45 0 0 1-.327-.134l-3.608-3.608a.45.45 0 0 1-.134-.327q0-.192.134-.327l1.108-1.108.633-.652 1.107-1.107a.45.45 0 0 1 .327-.135q.192 0 .327.135l3.608 3.607q.135.136.134.327a.45.45 0 0 1-.134.327l-1.108 1.108-.633.652-1.107 1.108a.45.45 0 0 1-.327.134M12.416 6.446l1.462 1.461.626.627 1.462 1.462q.441.44 1.066.44.627 0 1.067-.44l2.79-2.79q.223-.224.322-.503a1.7 1.7 0 0 0 .1-.577q0-.303-.1-.58a1.3 1.3 0 0 0-.322-.493l-3.55-3.55a1.4 1.4 0 0 0-.499-.325 1.7 1.7 0 0 0-.574-.102 1.47 1.47 0 0 0-1.06.446l-2.79 2.79q-.44.441-.44 1.067t.44 1.067m4.61 2.99a.45.45 0 0 1-.327-.135L13.09 5.694a.45.45 0 0 1-.135-.327q0-.193.135-.327l1.108-1.108.652-.633 1.107-1.107a.45.45 0 0 1 .327-.135q.193 0 .327.135l3.608 3.607q.135.136.134.327a.45.45 0 0 1-.134.327l-1.108 1.108-.652.633L17.353 9.3a.45.45 0 0 1-.327.135",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#satellite-color_svg__a)",
    fillRule: "evenodd",
    d: "m8.047 13.86 1.056-1.055-1.356-1.356a1.68 1.68 0 0 1-.507-1.232q0-.724.507-1.231L8.98 7.753a1.68 1.68 0 0 1 1.234-.508q.728 0 1.235.508l1.356 1.356 1.056-1.056.838.838-1.056 1.056L15 11.303q.508.508.5 1.24-.008.73-.515 1.239l-1.208 1.207q-.507.509-1.24.513a1.67 1.67 0 0 1-1.239-.503l-1.355-1.356L8.886 14.7z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#satellite-color_svg__b)",
    fillRule: "evenodd",
    d: "M14.42 22.924v-1.5q2.925 0 4.958-2.033t2.033-4.958h1.5q0 1.77-.669 3.316a8.6 8.6 0 0 1-1.815 2.691 8.6 8.6 0 0 1-2.69 1.815 8.3 8.3 0 0 1-3.316.669",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#satellite-color_svg__c)",
    fillRule: "evenodd",
    d: "M14.42 19.231v-1.5q1.376 0 2.337-.961.962-.962.962-2.337h1.5q0 1.989-1.405 3.394-1.405 1.404-3.393 1.404",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "satellite-color_svg__a",
    x1: 7.407,
    x2: 22.503,
    y1: 10,
    y2: 16.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF569D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#8E73BC",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E9FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "satellite-color_svg__b",
    x1: 7.407,
    x2: 22.503,
    y1: 10,
    y2: 16.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF569D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#8E73BC",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E9FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "satellite-color_svg__c",
    x1: 7.407,
    x2: 22.503,
    y1: 10,
    y2: 16.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF569D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#8E73BC",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E9FFF"
  })))));
};
export default SvgSatelliteColor;